import { ElementProps } from '@/components/sections/builder/types';
import { BlogPostTitleElementDataType } from '@/components/sections/builder/elements/body/blog-post/type';
import { getOverrideAnimationParams } from '@/components/sections/builder/settings/animation-setting';
import InputTab from '@/components/sections/builder/settings/input-tab';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import { Input } from '@/components/ui/input';
import { useBuilderStore } from '@/stores/builder';
import clsx from 'clsx';
import { shallow } from 'zustand/shallow';
import { Type } from 'lucide-react';

const defaultData: BlogPostTitleElementDataType = {
  name: 'Title',
  label: 'Our Blog',
  headingSize: 'medium',
  padding: {
    top: 0,
    bottom: 16,
    left: 0,
    right: 0,
  },
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as BlogPostTitleElementDataType;

  return (
    <>
      <h2
        data-animation='true'
        {...getOverrideAnimationParams(data.animation)}
        className={clsx(
          'theme_font_heading text-3xl font-extrabold tracking-tight',
          `blog-post-title-padding`,
          data.headingSize === 'large' && 'text-4xl @sm:text-4xl md:text-5xl lg:text-6xl',
          data.headingSize === 'medium' && 'text-3xl @sm:text-3xl md:text-4xl lg:text-5xl',
          data.headingSize === 'small' && 'text-2xl @sm:text-2xl md:text-3xl lg:text-4xl'
        )}
      >
        {data.label}
      </h2>
      <style jsx>
        {`
          @media (min-width: 768px) {
            .blog-post-title-padding {
              padding-top: ${data.padding?.top || 0}px;
              padding-bottom: ${data.padding?.bottom || 0}px;
              padding-left: ${data.padding?.left || 0}px;
              padding-right: ${data.padding?.right || 0}px;
            }
          }
        `}
      </style>
    </>
  );
};

export const ElementPreviewIcon = Type;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as BlogPostTitleElementDataType;

  return (
    <div>
      <div className='mb-4 font-bold'>Text</div>
      <Input
        onChange={(e) =>
          builder.setChildData(element.parentId as string, element.id, {
            label: e.target.value,
          })
        }
        name='label'
        type='text'
        size={100}
        defaultValue={data.label}
        className='w-full'
        placeholder='Label'
      />
      <div className='mb-4 mt-4 font-bold'>Heading Size</div>
      <InputTab
        defaultValue={data.headingSize}
        options={[
          { label: 'Small', value: 'small' },
          { label: 'Medium', value: 'medium' },
          { label: 'Large', value: 'large' },
        ]}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            headingSize: v,
          })
        }
      />
      <PaddingSetting
        value={data.padding}
        hideLeft={true}
        hideRight={true}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            padding: v,
          })
        }
      />
    </div>
  );
}

const BlogPostTitle = {
  type: 'blog_post_title',
  group: 'blog_post',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default BlogPostTitle;
